import api from '../core/api';
import VwStkDurumDTO from 'src/models/StokEczane/StokDurum/VwStkDurumDTO';
import VwStkDurumSearchDTO from 'src/models/StokEczane/StokDurum/VwStkDurumSearchDTO';
import VwStkAraDTO from 'src/models/StokEczane/StokDurum/VwStkAraDTO';
import VwStkUcrattarifeDTO from 'src/models/StokEczane/StokDurum/VwStkUcrattarifeDTO';
import VwStkCikishareketDTO from 'src/models/StokEczane/DepoDurum/VwStkCikishareketDTO';
import VwStkGirishareketDTO from 'src/models/StokEczane/DepoDurum/VwStkGirishareketDTO';

const controllerName = 'DepoDurum/';

export const DepoDurumApi = api.injectEndpoints({
    endpoints: (builder) => ({
        GetStokGiris: builder.query<
            VwStkGirishareketDTO[],
            { id: number }
        >({
            query: (req) => ({
                url: controllerName + 'GetStokGiris',
                method: 'GET',
                params: {
                    id: req.id
                }
            })
        }),
        GetStokCikis: builder.query<
            VwStkCikishareketDTO[],
            { id: number }
        >({
            query: (req) => ({
                url: controllerName + 'GetStokCikis',
                method: 'GET',
                params: {
                    id: req.id
                }
            })
        }),

    })
});

export const {
    useGetStokGirisQuery,
    useGetStokCikisQuery
} = DepoDurumApi;
